var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Groupe_760",
  "data-name": "Groupe 760",
  transform: "translate(1 -764.503)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Soustraction_1",
  "data-name": "Soustraction 1",
  d: "M481.5,259.194h0l-411.858-.125-.005-.005c-.132-.143-1.34-1.463-3.137-3.731V121.883a135.22,135.22,0,0,1,17.506-18.016,98.525,98.525,0,0,1,17.86-12.1,76.449,76.449,0,0,1,35.625-8.943,81.927,81.927,0,0,1,26.4,4.517,104.762,104.762,0,0,1,24.079,12c3.579,2.375,8.552,3.631,14.383,3.631,11.582,0,25.246-4.9,38.475-13.8,16.409-11.039,31.545-27.49,44.99-48.9a78.7,78.7,0,0,1,15.451-17.91A85.9,85.9,0,0,1,320.879,9.811a102.149,102.149,0,0,1,22.583-7.389A121.107,121.107,0,0,1,367.82,0a136.886,136.886,0,0,1,67.829,18.183A114.2,114.2,0,0,1,462.984,40.1,96.014,96.014,0,0,1,481.5,69.838v79.482a61.662,61.662,0,0,0,0,7.684V259.193Z",
  transform: "translate(-67 765)",
  fill: "#f3f3f3",
  stroke: "rgba(0,0,0,0)",
  strokeMiterlimit: 10,
  strokeWidth: 1
}), /*#__PURE__*/React.createElement("path", {
  id: "Trac\\xE9_843",
  "data-name": "Trac\\xE9 843",
  d: "M1969.894,536.257s-14.8-9.442-7-20.654c0,0,6.119-6.809,12.341-8.293,0,0-4.257,17.144-1.018,17.739s3.367-19.446,3.367-19.446,16.553-6.824,22.839-5.849c0,0-10.963,16.35-7.677,16.13s15.484-16.7,15.484-16.7,16.692-2.11,18.781,7.829-2.474,14.587-4.956,15.058-18.171-.634-17.88,1.429,10.706,5.934,16.725,4.438c0,0-7.45,15.734-15.966,14.427s-10.864-6.761-16.142-7.473-9.234.493-6.665,2.072,11.595,1.135,15.668,5.021,7.411,6.328-.635,7.5-22.26-.664-24.764-6.945Z",
  transform: "translate(-1632.356 359.727)",
  fill: "#dfdede"
}), /*#__PURE__*/React.createElement("path", {
  id: "Trac\\xE9_844",
  "data-name": "Trac\\xE9 844",
  d: "M2037.553,556.334s-43.615,11.407-49.4,26.623a32.58,32.58,0,0,1-4.933,14.651l-.175,3.059s5.083-10.141,7.611-11.428c0,0-8.811-14.008,46.9-32.9",
  transform: "translate(-1650.618 313.027)",
  fill: "#ccc"
}), /*#__PURE__*/React.createElement("path", {
  id: "Trac\\xE9_845",
  "data-name": "Trac\\xE9 845",
  d: "M1962.595,770.861s-7.18,9.649-4.116,22.071l1.725-.359s-.877-13.539,2.966-20.1-.575-1.609-.575-1.609",
  transform: "translate(-1629.989 139.774)",
  fill: "#c7dcfb"
}), /*#__PURE__*/React.createElement("path", {
  id: "Trac\\xE9_846",
  "data-name": "Trac\\xE9 846",
  d: "M1713.519,180.972s-22.741-4.994-18.147-22.519c0,0,4.508-11.272,11.577-15.963,0,0,2.531,23.29,6.836,22.551s-4.692-25.748-4.692-25.748,17.492-16.057,25.763-17.716c0,0-6.18,25.365-2.19,23.589s11.646-27.871,11.646-27.871,19.817-10.253,26.959,1.168,3.583,19.292.708,21.012-22.912,7.511-21.608,9.947,16.04,2.5,22.85-2.115c0,0-2.087,22.992-13.288,25.255s-16.614-3.455-23.511-1.93-11.271,4.832-7.351,5.625,14.955-3.884,21.8-.907,12.117,4.493,2.636,9.631-28.018,9.342-34,2.666Z",
  transform: "translate(-1415.832 674.03)",
  fill: "#dfdede"
}), /*#__PURE__*/React.createElement("path", {
  id: "Trac\\xE9_847",
  "data-name": "Trac\\xE9 847",
  d: "M1845.184,178.765s-49.091,34.127-49.34,55.712a43.208,43.208,0,0,1,.552,20.494l1.179,3.888s1.7-14.948,4.256-17.706c0,0-17.368-13.415,43.354-62.389",
  transform: "translate(-1498.156 620.524)",
  fill: "#ccc"
}), /*#__PURE__*/React.createElement("path", {
  id: "Trac\\xE9_848",
  "data-name": "Trac\\xE9 848",
  d: "M1794.073,575.464s-4.53,15.292,4.959,29.359l1.984-1.235s-7.278-16.456-5.491-26.383-1.452-1.741-1.452-1.741",
  transform: "translate(-1495.834 300.032)",
  fill: "#dfebfd"
}), /*#__PURE__*/React.createElement("path", {
  id: "Trac\\xE9_850",
  "data-name": "Trac\\xE9 850",
  d: "M791.215,433.688l-9.763,165.959a10.876,10.876,0,0,0,10.857,11.514h47.718Z",
  transform: "translate(-672.007 412.911)",
  fill: "#699dee"
}), /*#__PURE__*/React.createElement("path", {
  id: "Trac\\xE9_851",
  "data-name": "Trac\\xE9 851",
  d: "M832.169,440.987l4.747,164.6a10.876,10.876,0,0,0,10.857,11.514h47.718Z",
  transform: "translate(-713.328 406.967)",
  fill: "#aaa"
}), /*#__PURE__*/React.createElement("path", {
  id: "Trac\\xE9_852",
  "data-name": "Trac\\xE9 852",
  d: "M1069.076,607.972H880.928a9.728,9.728,0,0,1-9.569-7.978l-28.63-156.565a11.575,11.575,0,0,1,11.386-13.657h185.933a9.728,9.728,0,0,1,9.569,7.978l29.028,158.744a9.728,9.728,0,0,1-9.569,11.478",
  transform: "translate(-721.772 416.101)",
  fill: "#f5f5f5"
}), /*#__PURE__*/React.createElement("path", {
  id: "Trac\\xE9_853",
  "data-name": "Trac\\xE9 853",
  d: "M837.882,463.763h208.05L1040.6,434.2a5.386,5.386,0,0,0-5.3-4.43H833.776a1.764,1.764,0,0,0-1.735,2.081Z",
  transform: "translate(-713.2 416.1)",
  fill: "#ae1118"
}), /*#__PURE__*/React.createElement("path", {
  id: "Trac\\xE9_856",
  "data-name": "Trac\\xE9 856",
  d: "M1024.525,381.842a9.028,9.028,0,0,0-9.021,9.018h1.731a7.288,7.288,0,0,1,14.577,0,7.221,7.221,0,0,1-.375,2.307,7.314,7.314,0,0,1-4.529,4.58,7.229,7.229,0,0,1-1.97.39v1.733a8.908,8.908,0,0,0,2.3-.409,9.019,9.019,0,0,0-2.718-17.619",
  transform: "translate(-862.638 455.136)",
  fill: "#4b4b4b"
}), /*#__PURE__*/React.createElement("path", {
  id: "Trac\\xE9_857",
  "data-name": "Trac\\xE9 857",
  d: "M1061.988,465.4a2.01,2.01,0,0,1-.07.521,1.967,1.967,0,1,1,.07-.521",
  transform: "translate(-897.313 388.677)",
  fill: "#4b4b4b"
}), /*#__PURE__*/React.createElement("path", {
  id: "Trac\\xE9_858",
  "data-name": "Trac\\xE9 858",
  d: "M1198.781,381.842a9.028,9.028,0,0,0-9.02,9.018h1.731a7.289,7.289,0,0,1,14.577,0,7.214,7.214,0,0,1-.375,2.307,7.314,7.314,0,0,1-4.529,4.58,7.227,7.227,0,0,1-1.97.39v1.733a8.924,8.924,0,0,0,2.3-.409,9.019,9.019,0,0,0-2.718-17.619",
  transform: "translate(-1004.555 455.136)",
  fill: "#4b4b4b"
}), /*#__PURE__*/React.createElement("path", {
  id: "Trac\\xE9_859",
  "data-name": "Trac\\xE9 859",
  d: "M1236.244,465.4a2,2,0,0,1-.07.521,1.964,1.964,0,1,1,.07-.521",
  transform: "translate(-1039.231 388.677)",
  fill: "#4b4b4b"
}), /*#__PURE__*/React.createElement("path", {
  id: "Trac\\xE9_860",
  "data-name": "Trac\\xE9 860",
  d: "M1373.034,381.842a9.026,9.026,0,0,0-9.018,9.018h1.731a7.288,7.288,0,1,1,9.671,6.887,7.214,7.214,0,0,1-1.968.39v1.733a8.922,8.922,0,0,0,2.3-.409,9.019,9.019,0,0,0-2.72-17.619",
  transform: "translate(-1146.471 455.136)",
  fill: "#4b4b4b"
}), /*#__PURE__*/React.createElement("path", {
  id: "Trac\\xE9_861",
  "data-name": "Trac\\xE9 861",
  d: "M1410.5,465.4a2,2,0,0,1-.07.521,1.958,1.958,0,1,1,.07-.521",
  transform: "translate(-1181.147 388.677)",
  fill: "#4b4b4b"
}), /*#__PURE__*/React.createElement("path", {
  id: "Trac\\xE9_862",
  "data-name": "Trac\\xE9 862",
  d: "M1547.281,381.842a9.028,9.028,0,0,0-9.02,9.018h1.731a7.288,7.288,0,0,1,14.577,0,7.221,7.221,0,0,1-.375,2.307,7.314,7.314,0,0,1-4.532,4.58,7.2,7.2,0,0,1-1.968.39v1.733a8.9,8.9,0,0,0,2.3-.409,9.019,9.019,0,0,0-2.718-17.619",
  transform: "translate(-1288.378 455.136)",
  fill: "#4b4b4b"
}), /*#__PURE__*/React.createElement("path", {
  id: "Trac\\xE9_863",
  "data-name": "Trac\\xE9 863",
  d: "M1584.745,465.4a2.005,2.005,0,0,1-.07.521,1.959,1.959,0,1,1,.07-.521",
  transform: "translate(-1323.054 388.677)",
  fill: "#4b4b4b"
}), /*#__PURE__*/React.createElement("path", {
  id: "Trac\\xE9_864",
  "data-name": "Trac\\xE9 864",
  d: "M1721.537,381.842a9.028,9.028,0,0,0-9.02,9.018h1.731a7.288,7.288,0,0,1,14.577,0,7.211,7.211,0,0,1-.375,2.307,7.313,7.313,0,0,1-4.531,4.58,7.192,7.192,0,0,1-1.968.39v1.733a8.908,8.908,0,0,0,2.3-.409,9.019,9.019,0,0,0-2.718-17.619",
  transform: "translate(-1430.295 455.136)",
  fill: "#4b4b4b"
}), /*#__PURE__*/React.createElement("path", {
  id: "Trac\\xE9_865",
  "data-name": "Trac\\xE9 865",
  d: "M1759,465.4a2.005,2.005,0,0,1-.07.521,1.961,1.961,0,1,1,.07-.521",
  transform: "translate(-1464.97 388.677)",
  fill: "#4b4b4b"
}), /*#__PURE__*/React.createElement("path", {
  id: "Trac\\xE9_866",
  "data-name": "Trac\\xE9 866",
  d: "M1895.791,381.842a9.026,9.026,0,0,0-9.018,9.018h1.731a7.289,7.289,0,1,1,9.671,6.887,7.216,7.216,0,0,1-1.968.39v1.733a8.913,8.913,0,0,0,2.305-.409,9.019,9.019,0,0,0-2.72-17.619",
  transform: "translate(-1572.211 455.136)",
  fill: "#4b4b4b"
}), /*#__PURE__*/React.createElement("path", {
  id: "Trac\\xE9_867",
  "data-name": "Trac\\xE9 867",
  d: "M1933.256,465.4a2.005,2.005,0,0,1-.07.521,1.96,1.96,0,1,1,.07-.521",
  transform: "translate(-1606.886 388.677)",
  fill: "#4b4b4b"
}), /*#__PURE__*/React.createElement("path", {
  id: "Trac\\xE9_868",
  "data-name": "Trac\\xE9 868",
  d: "M1445.121,846.59H1434.6a2.819,2.819,0,0,1-2.637-2.211l-2.029-10.517a1.776,1.776,0,0,1,1.784-2.211h10.517a2.819,2.819,0,0,1,2.637,2.211l2.029,10.517a1.776,1.776,0,0,1-1.785,2.211",
  transform: "translate(-1200.126 88.805)",
  fill: "#dfdede"
}), /*#__PURE__*/React.createElement("path", {
  id: "Trac\\xE9_869",
  "data-name": "Trac\\xE9 869",
  d: "M1588.125,846.59h-10.517a2.819,2.819,0,0,1-2.637-2.211l-2.029-10.517a1.776,1.776,0,0,1,1.784-2.211h10.517a2.819,2.819,0,0,1,2.637,2.211l2.029,10.517a1.776,1.776,0,0,1-1.784,2.211",
  transform: "translate(-1316.589 88.805)",
  fill: "#dfdede"
}), /*#__PURE__*/React.createElement("path", {
  id: "Trac\\xE9_870",
  "data-name": "Trac\\xE9 870",
  d: "M1731.126,846.59h-10.517a2.819,2.819,0,0,1-2.637-2.211l-2.029-10.517a1.776,1.776,0,0,1,1.784-2.211h10.517a2.819,2.819,0,0,1,2.637,2.211l2.029,10.517a1.776,1.776,0,0,1-1.784,2.211",
  transform: "translate(-1433.051 88.805)",
  fill: "#bcbcbc"
}), /*#__PURE__*/React.createElement("path", {
  id: "Trac\\xE9_871",
  "data-name": "Trac\\xE9 871",
  d: "M1016.117,846.59H1005.6a2.819,2.819,0,0,1-2.637-2.211l-2.029-10.517a1.776,1.776,0,0,1,1.784-2.211h10.517a2.82,2.82,0,0,1,2.637,2.211l2.029,10.517a1.777,1.777,0,0,1-1.784,2.211",
  transform: "translate(-850.739 88.805)",
  fill: "#dfdede"
}), /*#__PURE__*/React.createElement("path", {
  id: "Trac\\xE9_873",
  "data-name": "Trac\\xE9 873",
  d: "M1159.119,846.59H1148.6a2.819,2.819,0,0,1-2.637-2.211l-2.029-10.517a1.776,1.776,0,0,1,1.784-2.211h10.517a2.819,2.819,0,0,1,2.637,2.211l2.029,10.517a1.776,1.776,0,0,1-1.784,2.211",
  transform: "translate(-967.201 88.805)",
  fill: "#dfdede"
}), /*#__PURE__*/React.createElement("path", {
  id: "Trac\\xE9_874",
  "data-name": "Trac\\xE9 874",
  d: "M1302.12,846.59H1291.6a2.82,2.82,0,0,1-2.637-2.211l-2.029-10.517a1.776,1.776,0,0,1,1.784-2.211h10.518a2.82,2.82,0,0,1,2.637,2.211l2.029,10.517a1.776,1.776,0,0,1-1.784,2.211",
  transform: "translate(-1083.663 88.805)",
  fill: "#dfdede"
}), /*#__PURE__*/React.createElement("path", {
  id: "Trac\\xE9_875",
  "data-name": "Trac\\xE9 875",
  d: "M1874.127,846.59H1863.61a2.819,2.819,0,0,1-2.637-2.211l-2.029-10.517a1.777,1.777,0,0,1,1.785-2.211h10.517a2.819,2.819,0,0,1,2.637,2.211l2.029,10.517a1.777,1.777,0,0,1-1.784,2.211",
  transform: "translate(-1549.513 88.805)",
  fill: "#bcbcbc"
}), /*#__PURE__*/React.createElement("path", {
  id: "Trac\\xE9_876",
  "data-name": "Trac\\xE9 876",
  d: "M1421.38,723.506h-10.517a2.819,2.819,0,0,1-2.637-2.211l-2.029-10.517a1.777,1.777,0,0,1,1.784-2.211H1418.5a2.82,2.82,0,0,1,2.637,2.211l2.028,10.517a1.776,1.776,0,0,1-1.784,2.211",
  transform: "translate(-1180.79 189.046)",
  fill: "#dfdede"
}), /*#__PURE__*/React.createElement("path", {
  id: "Trac\\xE9_877",
  "data-name": "Trac\\xE9 877",
  d: "M1564.381,723.506h-10.517a2.819,2.819,0,0,1-2.637-2.211l-2.029-10.517a1.777,1.777,0,0,1,1.784-2.211H1561.5a2.82,2.82,0,0,1,2.637,2.211l2.029,10.517a1.776,1.776,0,0,1-1.784,2.211",
  transform: "translate(-1297.252 189.046)",
  fill: "#dfdede"
}), /*#__PURE__*/React.createElement("path", {
  id: "Trac\\xE9_878",
  "data-name": "Trac\\xE9 878",
  d: "M1707.383,723.506h-10.517a2.82,2.82,0,0,1-2.637-2.211l-2.029-10.517a1.776,1.776,0,0,1,1.784-2.211H1704.5a2.82,2.82,0,0,1,2.637,2.211l2.029,10.517a1.776,1.776,0,0,1-1.784,2.211",
  transform: "translate(-1413.714 189.046)",
  fill: "#bcbcbc"
}), /*#__PURE__*/React.createElement("path", {
  id: "Trac\\xE9_879",
  "data-name": "Trac\\xE9 879",
  d: "M1850.384,723.506h-10.518a2.819,2.819,0,0,1-2.637-2.211l-2.029-10.517a1.776,1.776,0,0,1,1.785-2.211H1847.5a2.819,2.819,0,0,1,2.637,2.211l2.029,10.517a1.776,1.776,0,0,1-1.784,2.211",
  transform: "translate(-1530.176 189.046)",
  fill: "#bcbcbc"
}), /*#__PURE__*/React.createElement("path", {
  id: "Trac\\xE9_880",
  "data-name": "Trac\\xE9 880",
  d: "M1470.288,977.044H1459.77a2.82,2.82,0,0,1-2.637-2.21l-2.029-10.518a1.776,1.776,0,0,1,1.784-2.21h10.517a2.819,2.819,0,0,1,2.637,2.21l2.029,10.518a1.776,1.776,0,0,1-1.784,2.21",
  transform: "translate(-1220.621 -17.439)",
  fill: "#dfdede"
}), /*#__PURE__*/React.createElement("path", {
  id: "Trac\\xE9_881",
  "data-name": "Trac\\xE9 881",
  d: "M1613.288,977.044H1602.77a2.819,2.819,0,0,1-2.637-2.21l-2.029-10.518a1.777,1.777,0,0,1,1.785-2.21h10.517a2.819,2.819,0,0,1,2.637,2.21l2.029,10.518a1.776,1.776,0,0,1-1.784,2.21",
  transform: "translate(-1337.082 -17.439)",
  fill: "#dfdede"
}), /*#__PURE__*/React.createElement("path", {
  id: "Trac\\xE9_882",
  "data-name": "Trac\\xE9 882",
  d: "M1756.29,977.044h-10.517a2.819,2.819,0,0,1-2.637-2.21l-2.029-10.518a1.777,1.777,0,0,1,1.785-2.21h10.517a2.82,2.82,0,0,1,2.637,2.21l2.028,10.518a1.776,1.776,0,0,1-1.784,2.21",
  transform: "translate(-1453.545 -17.439)",
  fill: "#bcbcbc"
}), /*#__PURE__*/React.createElement("path", {
  id: "Trac\\xE9_883",
  "data-name": "Trac\\xE9 883",
  d: "M1041.281,977.044h-10.517a2.819,2.819,0,0,1-2.637-2.21l-2.029-10.518a1.776,1.776,0,0,1,1.784-2.21H1038.4a2.819,2.819,0,0,1,2.637,2.21l2.029,10.518a1.776,1.776,0,0,1-1.784,2.21",
  transform: "translate(-871.232 -17.439)",
  fill: "#dfdede"
}), /*#__PURE__*/React.createElement("path", {
  id: "Trac\\xE9_884",
  "data-name": "Trac\\xE9 884",
  d: "M1184.283,977.044h-10.517a2.82,2.82,0,0,1-2.637-2.21l-2.028-10.518a1.776,1.776,0,0,1,1.784-2.21H1181.4a2.82,2.82,0,0,1,2.637,2.21l2.029,10.518a1.776,1.776,0,0,1-1.784,2.21",
  transform: "translate(-987.696 -17.439)",
  fill: "#dfdede"
}), /*#__PURE__*/React.createElement("path", {
  id: "Trac\\xE9_885",
  "data-name": "Trac\\xE9 885",
  d: "M1327.285,977.044h-10.517a2.819,2.819,0,0,1-2.637-2.21l-2.029-10.518a1.776,1.776,0,0,1,1.784-2.21H1324.4a2.819,2.819,0,0,1,2.637,2.21l2.029,10.518a1.776,1.776,0,0,1-1.784,2.21",
  transform: "translate(-1104.158 -17.439)",
  fill: "#dfdede"
}), /*#__PURE__*/React.createElement("path", {
  id: "Trac\\xE9_886",
  "data-name": "Trac\\xE9 886",
  d: "M1899.292,977.044h-10.517a2.819,2.819,0,0,1-2.637-2.21l-2.029-10.518a1.777,1.777,0,0,1,1.785-2.21h10.517a2.82,2.82,0,0,1,2.637,2.21l2.029,10.518a1.776,1.776,0,0,1-1.784,2.21",
  transform: "translate(-1570.007 -17.439)",
  fill: "#bcbcbc"
}), /*#__PURE__*/React.createElement("path", {
  id: "Trac\\xE9_887",
  "data-name": "Trac\\xE9 887",
  d: "M1495.451,1107.5h-10.517a2.819,2.819,0,0,1-2.637-2.211l-2.029-10.517a1.777,1.777,0,0,1,1.784-2.211h10.517a2.82,2.82,0,0,1,2.637,2.211l2.029,10.517a1.776,1.776,0,0,1-1.784,2.211",
  transform: "translate(-1241.114 -123.683)",
  fill: "#dfdede"
}), /*#__PURE__*/React.createElement("path", {
  id: "Trac\\xE9_888",
  "data-name": "Trac\\xE9 888",
  d: "M1638.453,1107.5h-10.517a2.819,2.819,0,0,1-2.637-2.211l-2.028-10.517a1.776,1.776,0,0,1,1.784-2.211h10.517a2.82,2.82,0,0,1,2.637,2.211l2.028,10.517a1.776,1.776,0,0,1-1.784,2.211",
  transform: "translate(-1357.578 -123.683)",
  fill: "#dfdede"
}), /*#__PURE__*/React.createElement("path", {
  id: "Trac\\xE9_889",
  "data-name": "Trac\\xE9 889",
  d: "M1781.454,1107.5h-10.517a2.819,2.819,0,0,1-2.637-2.211l-2.029-10.517a1.776,1.776,0,0,1,1.784-2.211h10.517a2.82,2.82,0,0,1,2.637,2.211l2.029,10.517a1.776,1.776,0,0,1-1.785,2.211",
  transform: "translate(-1474.04 -123.683)",
  fill: "#bcbcbc"
}), /*#__PURE__*/React.createElement("path", {
  id: "Trac\\xE9_890",
  "data-name": "Trac\\xE9 890",
  d: "M1066.445,1107.5h-10.517a2.819,2.819,0,0,1-2.637-2.211l-2.029-10.517a1.777,1.777,0,0,1,1.784-2.211h10.517a2.819,2.819,0,0,1,2.637,2.211l2.029,10.517a1.776,1.776,0,0,1-1.784,2.211",
  transform: "translate(-891.727 -123.683)",
  fill: "#dfdede"
}), /*#__PURE__*/React.createElement("path", {
  id: "Trac\\xE9_891",
  "data-name": "Trac\\xE9 891",
  d: "M1209.447,1107.5h-10.517a2.819,2.819,0,0,1-2.637-2.211l-2.029-10.517a1.777,1.777,0,0,1,1.784-2.211h10.517a2.819,2.819,0,0,1,2.637,2.211l2.029,10.517a1.776,1.776,0,0,1-1.784,2.211",
  transform: "translate(-1008.189 -123.683)",
  fill: "#cb2129"
}), /*#__PURE__*/React.createElement("path", {
  id: "Trac\\xE9_892",
  "data-name": "Trac\\xE9 892",
  d: "M1352.449,1107.5h-10.517a2.819,2.819,0,0,1-2.637-2.211l-2.028-10.517a1.776,1.776,0,0,1,1.784-2.211h10.517a2.82,2.82,0,0,1,2.637,2.211l2.029,10.517a1.776,1.776,0,0,1-1.784,2.211",
  transform: "translate(-1124.652 -123.683)",
  fill: "#dfdede"
}), /*#__PURE__*/React.createElement("path", {
  id: "Trac\\xE9_893",
  "data-name": "Trac\\xE9 893",
  d: "M1924.456,1107.5h-10.517a2.819,2.819,0,0,1-2.637-2.211l-2.029-10.517a1.777,1.777,0,0,1,1.784-2.211h10.517a2.819,2.819,0,0,1,2.637,2.211l2.029,10.517a1.776,1.776,0,0,1-1.784,2.211",
  transform: "translate(-1590.502 -123.683)",
  fill: "#bcbcbc"
}), /*#__PURE__*/React.createElement("path", {
  id: "Trac\\xE9_894",
  "data-name": "Trac\\xE9 894",
  d: "M1519.193,1230.583h-10.517a2.819,2.819,0,0,1-2.637-2.211l-2.029-10.517a1.777,1.777,0,0,1,1.784-2.211h10.517a2.82,2.82,0,0,1,2.637,2.211l2.029,10.517a1.776,1.776,0,0,1-1.784,2.211",
  transform: "translate(-1260.45 -223.923)",
  fill: "#dfdede"
}), /*#__PURE__*/React.createElement("path", {
  id: "Trac\\xE9_895",
  "data-name": "Trac\\xE9 895",
  d: "M1662.2,1230.583h-10.517a2.819,2.819,0,0,1-2.637-2.211l-2.029-10.517a1.776,1.776,0,0,1,1.784-2.211h10.518a2.819,2.819,0,0,1,2.637,2.211l2.029,10.517a1.776,1.776,0,0,1-1.784,2.211",
  transform: "translate(-1376.914 -223.923)",
  fill: "#dfdede"
}), /*#__PURE__*/React.createElement("path", {
  id: "Trac\\xE9_896",
  "data-name": "Trac\\xE9 896",
  d: "M1805.2,1230.583h-10.517a2.819,2.819,0,0,1-2.637-2.211l-2.029-10.517a1.777,1.777,0,0,1,1.784-2.211h10.517a2.82,2.82,0,0,1,2.637,2.211l2.029,10.517a1.776,1.776,0,0,1-1.784,2.211",
  transform: "translate(-1493.375 -223.923)",
  fill: "#bcbcbc"
}), /*#__PURE__*/React.createElement("path", {
  id: "Trac\\xE9_897",
  "data-name": "Trac\\xE9 897",
  d: "M1090.188,1230.583H1079.67a2.819,2.819,0,0,1-2.637-2.211L1075,1217.855a1.777,1.777,0,0,1,1.784-2.211h10.517a2.819,2.819,0,0,1,2.637,2.211l2.029,10.517a1.777,1.777,0,0,1-1.784,2.211",
  transform: "translate(-911.063 -223.923)",
  fill: "#dfdede"
}), /*#__PURE__*/React.createElement("path", {
  id: "Trac\\xE9_898",
  "data-name": "Trac\\xE9 898",
  d: "M1233.189,1230.583h-10.517a2.819,2.819,0,0,1-2.637-2.211l-2.029-10.517a1.776,1.776,0,0,1,1.784-2.211h10.517a2.82,2.82,0,0,1,2.637,2.211l2.029,10.517a1.776,1.776,0,0,1-1.784,2.211",
  transform: "translate(-1027.526 -223.923)",
  fill: "#dfdede"
}), /*#__PURE__*/React.createElement("path", {
  id: "Trac\\xE9_899",
  "data-name": "Trac\\xE9 899",
  d: "M1376.191,1230.583h-10.518a2.819,2.819,0,0,1-2.637-2.211l-2.029-10.517a1.776,1.776,0,0,1,1.784-2.211h10.517a2.82,2.82,0,0,1,2.637,2.211l2.028,10.517a1.776,1.776,0,0,1-1.784,2.211",
  transform: "translate(-1143.988 -223.923)",
  fill: "#dfdede"
}), /*#__PURE__*/React.createElement("path", {
  id: "Trac\\xE9_900",
  "data-name": "Trac\\xE9 900",
  d: "M1067.028,713.091h-27.863a.747.747,0,0,1,0-1.493h27.863a.747.747,0,0,1,0,1.493",
  transform: "translate(-881.3 186.578)",
  fill: "#e9e9e9"
}), /*#__PURE__*/React.createElement("path", {
  id: "Trac\\xE9_901",
  "data-name": "Trac\\xE9 901",
  d: "M1071.594,731.274h-27.863a.747.747,0,1,1,0-1.493h27.863a.747.747,0,1,1,0,1.493",
  transform: "translate(-885.018 171.77)",
  fill: "#e9e9e9"
}), /*#__PURE__*/React.createElement("path", {
  id: "Trac\\xE9_903",
  "data-name": "Trac\\xE9 903",
  d: "M1124.716,571.749h-9.561a1.424,1.424,0,1,1,0-2.848h9.561a1.424,1.424,0,0,1,0,2.848",
  transform: "translate(-942.635 302.792)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Trac\\xE9_904",
  "data-name": "Trac\\xE9 904",
  d: "M1266.084,571.749h-9.561a1.424,1.424,0,0,1,0-2.848h9.561a1.424,1.424,0,0,1,0,2.848",
  transform: "translate(-1057.767 302.792)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Trac\\xE9_905",
  "data-name": "Trac\\xE9 905",
  d: "M1407.451,571.749h-9.562a1.424,1.424,0,0,1,0-2.848h9.562a1.424,1.424,0,0,1,0,2.848",
  transform: "translate(-1172.898 302.792)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Trac\\xE9_906",
  "data-name": "Trac\\xE9 906",
  d: "M1548.818,571.749h-9.562a1.424,1.424,0,0,1,0-2.848h9.562a1.424,1.424,0,1,1,0,2.848",
  transform: "translate(-1288.03 302.792)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Trac\\xE9_907",
  "data-name": "Trac\\xE9 907",
  d: "M1690.187,571.749h-9.561a1.424,1.424,0,0,1,0-2.848h9.561a1.424,1.424,0,1,1,0,2.848",
  transform: "translate(-1403.162 302.792)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Trac\\xE9_908",
  "data-name": "Trac\\xE9 908",
  d: "M1831.554,571.749h-9.562a1.424,1.424,0,0,1,0-2.848h9.562a1.424,1.424,0,0,1,0,2.848",
  transform: "translate(-1518.293 302.792)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Trac\\xE9_909",
  "data-name": "Trac\\xE9 909",
  d: "M1531.241,708.559c-2.111,0-3.649-.67-4.487-1.971-1.607-2.494-.366-5.99,3.687-10.391a51.385,51.385,0,0,1,6.451-5.786.305.305,0,1,1,.361.492c-.135.1-13.459,9.964-9.985,15.355,1.1,1.708,3.455,1.821,5.24,1.614,3.3-.382,7.6-2.16,11.513-4.756,4.046-2.687,6.9-5.715,7.819-8.308.606-1.7.418-2.906-.558-3.581-1.26-.872-3.893-.873-7.043,0a22.228,22.228,0,0,0-7.924,3.919.305.305,0,0,1-.394-.466,22.882,22.882,0,0,1,8.156-4.041c3.372-.932,6.125-.9,7.553.089.846.586,1.669,1.8.785,4.288-.967,2.715-3.9,5.854-8.056,8.612-3.985,2.647-8.389,4.461-11.781,4.854a11.714,11.714,0,0,1-1.336.081",
  transform: "translate(-1278.453 204.201)",
  fill: "#cb2129"
}), /*#__PURE__*/React.createElement("path", {
  id: "Trac\\xE9_910",
  "data-name": "Trac\\xE9 910",
  d: "M1816.657,660.885l-1.086-2.048s.539-3.649-4.033-5.957a2.232,2.232,0,0,0-2.615.682c-.869,1.255,1.656,1.028,1.52,3.176a3.949,3.949,0,0,0,2.3,4.107l1.173,1.359Z",
  transform: "translate(-1508.661 234.536)",
  fill: "#ffb27d"
}), /*#__PURE__*/React.createElement("path", {
  id: "Trac\\xE9_911",
  "data-name": "Trac\\xE9 911",
  d: "M1875.329,667.28s-3.927,19.271-25.534,25.568c-6.745,1.966-22.068-20.24-22.068-20.24s.539-2.047,3.914-1.577c0,0,14.92,9.877,16.8,10.95,1.667.952,12.627-12.239,17.624-14.367a12.753,12.753,0,0,1,9.266-.334",
  transform: "translate(-1524.123 223.247)",
  fill: "#2a2a2a"
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_1859",
  "data-name": "Rectangle 1859",
  width: 23.919,
  height: 4.755,
  transform: "matrix(0.985, -0.174, 0.174, 0.985, 288.061, 890.872)",
  fill: "#cb2129"
}), /*#__PURE__*/React.createElement("path", {
  id: "Trac\\xE9_912",
  "data-name": "Trac\\xE9 912",
  d: "M1716.656,671.87l5.9,1.325-.866-4.675Z",
  transform: "translate(-1433.665 222.269)",
  fill: "#ffb27d"
}), /*#__PURE__*/React.createElement("path", {
  id: "Trac\\xE9_916",
  "data-name": "Trac\\xE9 916",
  d: "M1977.508,927.573s.794,9.758,1.728,21.489c1.269,15.935,2.8,35.508,2.946,39.216.26,6.439,1.308,16.738,1.308,16.738s2.483,2.447,7.453,1.416a166.221,166.221,0,0,0,5.694-30.259c.02-.255.039-.512.059-.768,1.177-15.836,3.007-49.183,3.007-49.183Z",
  transform: "translate(-1646.106 11.786)",
  fill: "#cb2129"
}), /*#__PURE__*/React.createElement("path", {
  id: "Trac\\xE9_917",
  "data-name": "Trac\\xE9 917",
  d: "M1977.508,927.573s.794,9.758,1.728,21.489l17.4,27.111c.02-.255.039-.512.059-.768,1.177-15.836,3.007-49.183,3.007-49.183Z",
  transform: "translate(-1646.106 11.786)",
  fill: "#ae1118"
}), /*#__PURE__*/React.createElement("path", {
  id: "Trac\\xE9_918",
  "data-name": "Trac\\xE9 918",
  d: "M1997.055,911.782s14.318,35.342,23.732,51.95,12.356,21.244,12.356,21.244,5.393-2.125,5.884-3.573c0,0-3.6-32.064-9.9-39.88-3.562-4.417-7.747-17.671-7.943-22.306s-1.275-13.808-1.275-13.808Z",
  transform: "translate(-1662.026 28.736)",
  fill: "#cb2129"
}), /*#__PURE__*/React.createElement("path", {
  id: "Trac\\xE9_919",
  "data-name": "Trac\\xE9 919",
  d: "M2031.539,594.769s-9.688,4.674-15.272,2.94a13.171,13.171,0,0,1,3.78-3.025c-.193-1.121-.343-2.094-.429-2.919a26.968,26.968,0,0,1-.236-2.982l3.737-2.94,3.545-2.813a14.283,14.283,0,0,0,4.876,11.739",
  transform: "translate(-1677.672 291.286)",
  fill: "#ffb27d"
}), /*#__PURE__*/React.createElement("path", {
  id: "Trac\\xE9_920",
  "data-name": "Trac\\xE9 920",
  d: "M1973.362,690.75a.873.873,0,0,0,.582.232c2.1-.043,8.226,1.12,13.4.592a39.593,39.593,0,0,0,12.394-3.509c.559-.254,1.828-.931,1.8-1.523-.023-.677-.086-1.628-.171-2.857-.174-2.417-.418-5.847-.5-9.915-.058-3.016-.025-6.381.194-9.945.013-.239.025-.481.035-.723.063-1.306.093-2.623.093-3.909a67.922,67.922,0,0,0-.878-11.632c-1.055-6.134-3.031-10.935-5.951-13.072-.388-.3-2.794.866-5.027,1.946a9.289,9.289,0,0,1-6.013.72l-1.933,1.691a19.091,19.091,0,0,0-6.059,9.517c-.944,3.766-1.5,10.575-1.8,17.64-.148,3.214-.256,6.429-.3,9.495v.106c-.023.317-.023.637-.023.954-.106,7.846,0,14.086.151,14.192",
  transform: "translate(-1642.573 249.416)",
  fill: "#434343"
}), /*#__PURE__*/React.createElement("path", {
  id: "Trac\\xE9_921",
  "data-name": "Trac\\xE9 921",
  d: "M2040.4,598.4s-2.448,4.463-7.11,5.711a26.929,26.929,0,0,1-.237-2.982l3.738-2.94Z",
  transform: "translate(-1691.34 278.942)",
  fill: "#ed985f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Trac\\xE9_922",
  "data-name": "Trac\\xE9 922",
  d: "M2015.954,547.269s9.241,1.512,10.109-4.169,2.644-9.313-3.219-10.518-7.344.792-8.1,2.62-1.169,11.528,1.213,12.068",
  transform: "translate(-1675.948 332.671)",
  fill: "#ffb27d"
}), /*#__PURE__*/React.createElement("path", {
  id: "Trac\\xE9_923",
  "data-name": "Trac\\xE9 923",
  d: "M2016.315,516.756c.084-.1.277-.174.708-.2a1.745,1.745,0,0,0-.8-.227,2.167,2.167,0,0,0-1.44-1.916,1.291,1.291,0,0,1,.626.932c-1.193-1.226-3.751-2.118-10.834-1.559-9.334.737-6.258,6.713-5.049,7.426s4.25-1.241,6.5-1.062,2.679,3.432,3.444,3.879.463-.343,1.5-.81,1.132,1.245.833,2.359,1.121,2.582,1.121,2.582l1.435-1.545c1.435-1.545,2.787-8.091,2.135-9.486-.058-.123-.115-.248-.174-.374",
  transform: "translate(-1662.842 347.815)",
  fill: "#531f00"
}), /*#__PURE__*/React.createElement("path", {
  id: "Trac\\xE9_924",
  "data-name": "Trac\\xE9 924",
  d: "M1832.92,668.826s.318-1.256-.553-1.821-1.672-2.1-2.04-1.892c-.761.431.417,1.771.2,3.442-.075.585,1.287,2.118,2.393.271",
  transform: "translate(-1526.029 224.451)",
  fill: "#ffb27d"
}), /*#__PURE__*/React.createElement("path", {
  id: "Trac\\xE9_925",
  "data-name": "Trac\\xE9 925",
  d: "M2097.635,762.941c-.058-3.016-.025-6.381.193-9.945.012-.239.025-.481.036-.722-.879-4.352-2.208-8.214-4.163-8.339,0,0-5.828,9.157,3.935,19.007",
  transform: "translate(-1739.329 160.243)",
  fill: "#2a2a2a"
}), /*#__PURE__*/React.createElement("path", {
  id: "Trac\\xE9_926",
  "data-name": "Trac\\xE9 926",
  d: "M2137.9,927.19s-.486,4.722-1.019,5.616a20.123,20.123,0,0,1-3.769,4.307c-.967.56.59-3.761.393-4.6s-.8,1.534-1.221,1.59-.317-2.082-.332-2.86,2.073-2.7,2.809-4.355,3.138.3,3.138.3",
  transform: "translate(-1771.885 11.786)",
  fill: "#ffb27d"
}), /*#__PURE__*/React.createElement("path", {
  id: "Trac\\xE9_927",
  "data-name": "Trac\\xE9 927",
  d: "M2067.965,634.441s5.848,2.769,8.651,7.026c4.349,6.6,9.39,30.667,9.483,32.9s-3.679,17.961-3.679,17.961-3.826-.252-4.812-2.183c0,0,.764-16.164.279-17.2s-15.95-21.683-14.211-26.088,4.29-12.407,4.29-12.407",
  transform: "translate(-1716.171 249.416)",
  fill: "#434343"
}), /*#__PURE__*/React.createElement("path", {
  id: "Trac\\xE9_928",
  "data-name": "Trac\\xE9 928",
  d: "M1719.68,675.732l.308,2.76-3.332-.748Z",
  transform: "translate(-1433.665 216.395)",
  fill: "#2a2a2a"
}), /*#__PURE__*/React.createElement("path", {
  id: "Trac\\xE9_914",
  "data-name": "Trac\\xE9 914",
  d: "M2180.6,1318.069s2.68,2.446,2.157,4.184-2.942,2.9-3.269,5.021-1.634,3.283-2.811,3.283h-5.611s-.867-1.5,1.226-1.946,2.881-2.947,2.751-5.264a40.8,40.8,0,0,1,.2-5.407l4.446-1.03Z",
  transform: "translate(-1803.599 -306.396)",
  fill: "#2a2a2a"
}), /*#__PURE__*/React.createElement("path", {
  id: "Trac\\xE9_915",
  "data-name": "Trac\\xE9 915",
  d: "M1976.878,1347.79s.481,5.567-.7,6.147l-15.06-.031s0-1.738,2.419-2.124,6.668-1.8,7.388-4.957,5.949.966,5.949.966",
  transform: "translate(-1632.762 -329.79)",
  fill: "#2a2a2a"
}), /*#__PURE__*/React.createElement("path", {
  id: "Trac\\xE9_929",
  "data-name": "Trac\\xE9 929",
  d: "M2339.6,1307.889h-16.851c-.9-.766.624-2.506,2.221-2.623a9.85,9.85,0,0,1,2.572.3c.232-3.08,1.555-16.926,6.546-16.369,5.612.623,0,6.1-1.586,9.339a77.227,77.227,0,0,0-2.981,7.468c.455.1.927.2,1.409.284.744-2.284,3.511-9.966,7.031-9.518,4.132.524,2.471,3.6-.458,5.433-2.148,1.344-4.787,3.255-6.041,4.178a17.85,17.85,0,0,0,3.3.264c2.886-.068,4.3.782,4.842,1.24",
  transform: "translate(-1937.053 -283.816)",
  fill: "#82b378"
}), /*#__PURE__*/React.createElement("path", {
  id: "Trac\\xE9_834",
  "data-name": "Trac\\xE9 834",
  d: "M620.357,596.292s-28.44-40.482-39.554-35.234,39.554,35.234,39.554,35.234",
  transform: "translate(-507.315 309.562)",
  fill: "#a8d29f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Trac\\xE9_835",
  "data-name": "Trac\\xE9 835",
  d: "M735.257,565.875s-4.344-30.439-11.192-29.244,11.192,29.244,11.192,29.244",
  transform: "translate(-624.022 329.102)",
  fill: "#a8d29f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Trac\\xE9_836",
  "data-name": "Trac\\xE9 836",
  d: "M447.017,1138.624s2.734-13.544-7.883-15.246c0,0-7.2-.251-11.44,2.464,0,0,12.041,6.951,10.609,9.112s-12.858-8.714-12.858-8.714-12.908,5.653-15.788,9.748c0,0,15.253,2.718,13.333,4.459s-17.923-.349-17.923-.349-10.313,8.306-5.821,14.919,9.617,6.565,11.24,5.416,9.565-10.643,10.575-9.352-2.485,9.308-6.62,11.9c0,0,12.985,4.372,16.9-1.169s2.1-9.848,4.581-13.229,5.323-4.964,4.815-2.645-5.69,7.19-5.712,11.621-.462,7.656,4.6,3.738,11.782-12.977,9.59-17.827Z",
  transform: "translate(-359.827 -148.776)",
  fill: "#82b378"
}), /*#__PURE__*/React.createElement("path", {
  id: "Trac\\xE9_837",
  "data-name": "Trac\\xE9 837",
  d: "M434.954,1215.2s30.286-18.485,42.067-13.452a25.643,25.643,0,0,0,11,5.207l1.829,1.571s-8.523-2.659-10.633-1.929c0,0-3.126-12.643-44.259,8.6",
  transform: "translate(-389.831 -211.896)",
  fill: "#82b378"
}), /*#__PURE__*/React.createElement("path", {
  id: "Trac\\xE9_838",
  "data-name": "Trac\\xE9 838",
  d: "M711.426,1233.568a22.265,22.265,0,0,1,14.755,9.723l-1.146.782s-7.193-7.892-13.012-9.3-.6-1.205-.6-1.205",
  transform: "translate(-613.24 -238.513)",
  fill: "#82b378"
}), /*#__PURE__*/React.createElement("path", {
  id: "Trac\\xE9_839",
  "data-name": "Trac\\xE9 839",
  d: "M357.579,742.691s21.992-12.316,11.729-29.03c0,0-8.21-10.263-17.007-12.9,0,0,4.692,24.924,0,25.511s-3.225-28.15-3.225-28.15-23.165-11.143-32.255-10.263c0,0,14.368,24.338,9.677,23.752s-20.819-25.218-20.819-25.218-23.752-4.4-27.564,9.676,2.346,21.113,5.865,21.992,26.1.587,25.511,3.519-15.834,7.624-24.338,4.985c0,0,9.383,23.165,21.7,21.992s16.128-8.8,23.752-9.384,13.2,1.466,9.383,3.519-16.714.673-22.872,5.908-11.143,8.46.293,10.806,31.962.88,36.067-7.917Z",
  transform: "translate(-261.119 207.638)",
  fill: "#a8d29f"
}), /*#__PURE__*/React.createElement("path", {
  id: "Trac\\xE9_840",
  "data-name": "Trac\\xE9 840",
  d: "M341.853,765.085s61.578,19.94,68.616,42.225a46.779,46.779,0,0,0,5.865,21.406v4.4s-6.451-14.955-9.97-17.007c0,0,13.782-19.353-64.511-51.022",
  transform: "translate(-314.008 143.018)",
  fill: "#82b378"
}), /*#__PURE__*/React.createElement("path", {
  id: "Trac\\xE9_841",
  "data-name": "Trac\\xE9 841",
  d: "M730.264,1095.935s9.5,14.421,4.083,31.975l-2.443-.656s2.372-19.335-2.6-29.059.958-2.26.958-2.26",
  transform: "translate(-627.939 -124.201)",
  fill: "#82b378"
}), /*#__PURE__*/React.createElement("path", {
  id: "Trac\\xE9_842",
  "data-name": "Trac\\xE9 842",
  d: "M687.162,437.4l-32.9,170.112a5.607,5.607,0,0,0,5.505,6.672h17.354Z",
  transform: "translate(-568.35 409.891)",
  fill: "#7a7a7a"
}), /*#__PURE__*/React.createElement("path", {
  id: "Trac\\xE9_930",
  "data-name": "Trac\\xE9 930",
  d: "M303.187,1313.229c-.893-1.4-3.581-5.044-7.16-4.562-3.9.525,4.307,3.1,6.821,4.573a4.168,4.168,0,0,1-1.39-.163c-1.68-.6-4.557.55-5.477.953h15.993a2.534,2.534,0,0,0-1.144-1.462,2.855,2.855,0,0,0-1.472-.131c.951-1.121,1.611-4.7-1.036-3.781-1.934.673-1.929,2.861-1.739,4.156-.411.065-.828.13-1.241.189-.8-4.058-3.613-15.952-9.321-16.269-5.787-.321,4.907,12.335,8.468,16.383-.456.055-.9.1-1.3.115",
  transform: "translate(-275.311 -289.956)",
  fill: "#82b378"
}), /*#__PURE__*/React.createElement("path", {
  id: "Trac\\xE9_849",
  "data-name": "Trac\\xE9 849",
  d: "M738.087,431.041l-21.81,167.024a9.252,9.252,0,0,0,9.174,10.449h31.995L739.406,430.438Z",
  transform: "translate(-618.879 415.559)",
  fill: "#ccc"
}), /*#__PURE__*/React.createElement("path", {
  id: "Trac\\xE9_854",
  "data-name": "Trac\\xE9 854",
  d: "M850.268,381.842a9.028,9.028,0,0,0-9.02,9.018h1.733a7.289,7.289,0,0,1,14.577,0,7.221,7.221,0,0,1-.375,2.307,7.312,7.312,0,0,1-4.531,4.58,7.212,7.212,0,0,1-1.968.39v1.733a8.9,8.9,0,0,0,2.3-.409,9.019,9.019,0,0,0-2.72-17.619",
  transform: "translate(-720.722 455.136)",
  fill: "#4b4b4b"
}), /*#__PURE__*/React.createElement("path", {
  id: "Trac\\xE9_855",
  "data-name": "Trac\\xE9 855",
  d: "M887.743,465.4a2,2,0,0,1-.07.521,1.958,1.958,0,1,1,.07-.521",
  transform: "translate(-755.407 388.677)",
  fill: "#4b4b4b"
}), /*#__PURE__*/React.createElement("path", {
  id: "Trac\\xE9_872",
  "data-name": "Trac\\xE9 872",
  d: "M992.1,713.836h-4.52a1.212,1.212,0,0,1-1.133-.95l-.872-4.52a.763.763,0,0,1,.767-.95h4.52a1.212,1.212,0,0,1,1.133.95l.872,4.52a.763.763,0,0,1-.767.95",
  transform: "translate(-838.252 189.984)",
  fill: "#cb2129"
}), /*#__PURE__*/React.createElement("path", {
  id: "Trac\\xE9_902",
  "data-name": "Trac\\xE9 902",
  d: "M983.348,571.749h-9.561a1.424,1.424,0,1,1,0-2.848h9.561a1.424,1.424,0,1,1,0,2.848",
  transform: "translate(-827.503 302.792)",
  fill: "#fff"
}));

function SvgRdv(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 416,
    height: 260.189,
    viewBox: "0 0 416 260.189",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRdv);
export default __webpack_public_path__ + "static/media/rdv.fb761619d875c0e00d8f45ab2173a16c.svg";
export { ForwardRef as ReactComponent };